module.exports = __webpack_public_path__ + "static/media/home.a2516e70.jpg";